import { CiMoneyCheck1 } from "react-icons/ci";
import { PiInvoiceBold } from "react-icons/pi";
import { BsHouseGearFill, BsHouseLockFill } from "react-icons/bs";
import { FaAirbnb, FaFileInvoiceDollar } from "react-icons/fa";
import { GoReport } from "react-icons/go";
import { RiInbox2Line } from "react-icons/ri";

export const foldersInfo = (inmueble) =>  [
    {
        text:"Archivo permanente",
        condition:()=>true,
        route:"archivo_permanente",
        icon: RiInbox2Line,
        bg:"bg-rs-azul/85"
    },
    {
        text:"Hipoteca",
        condition:()=>inmueble.isMortgaged, error:"Este inmueble no está hipotecado",
        route:"hipoteca",
        icon:BsHouseLockFill,
        bg:inmueble.isMortgaged ? "bg-rs-azul/85" : "bg-gray-500"
    },
    {
        text:"Archivos de renta",
        condition:()=>true,
        route:"archivos_renta",
        icon:FaFileInvoiceDollar,
        bg:inmueble.isRented ? "bg-rs-azul/85" : "bg-rs-rojo/85"
    },
    {
        text:"Estado cuenta renta",
        condition:()=>true,
        route:"estado_cuenta",
        icon:CiMoneyCheck1,
        bg:inmueble.isRented ? "bg-rs-azul/85" : "bg-rs-rojo/85"
    },
    {
        text:"Facturas",
        condition:()=>true,
        route:"facturas",
        icon:PiInvoiceBold,
        bg:inmueble.isRented ? "bg-rs-azul/85" : "bg-rs-rojo/85"
    },
    {
        text:"Quejas y reportes",
        condition:()=>true,
        route:"quejas_reportes",
        icon: GoReport,
        bg:"bg-rs-azul/85"
    },
    {
        text:"Mantenimiento",
        condition:()=>true,
        route:"mantenimiento",
        icon: BsHouseGearFill,
        bg:"bg-rs-azul/85"
    },
    {
        text:"Airbnb",
        condition: () => inmueble.type === "Airbnb",
        route:"airbnb",
        icon: FaAirbnb,
        bg:"bg-rs-azul/85"
    },
];

export const foldersUserInfo = (inmueble) =>  [
    {
        text:"Archivos de renta",
        condition:()=>true,
        route:"archivos_renta",
        icon:FaFileInvoiceDollar,
        bg:inmueble.isRented ? "bg-rs-azul/85" : "bg-gray-500"
    },
    {
        text:"Estado cuenta renta",
        condition:()=>true,
        route:"estado_cuenta",
        icon:CiMoneyCheck1,
        bg:inmueble.isRented ? "bg-rs-azul/85" : "bg-gray-500"
    },
    {
        text:"Facturas",
        condition:()=>true,
        route:"facturas",
        icon:PiInvoiceBold,
        bg:inmueble.isRented ? "bg-rs-azul/85" : "bg-gray-500"
    },
    {
        text:"Quejas y reportes",
        condition:()=>true,
        route:"quejas_reportes",
        icon: GoReport,
        bg:"bg-rs-azul/85"
    },
];
